import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  downloadInVersion: {
    id:
      'views.ArticleDetail.ArticleDetailView.ArticlePrintings.downloadInVersion',
    defaultMessage: 'Pobierz załączniki:'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/ArticlePrintings/ArticlePrintings.intl.js